import React from 'react';
import { Wrapper } from './WidgetGalleriesGrid.style';
import GalleriesGrid from 'components/GalleriesGrid';

function WidgetGalleriesGrid({
  title = '',
  titleColor = undefined,
  titleBackground = undefined,
  linkBackground = undefined,
  linkColor = undefined,
  linkText = '',
  slug = '',

  data = []
}) {
  return (
    <Wrapper>
      <GalleriesGrid
        title={title}
        titleColor={titleColor}
        titleBackground={titleBackground}
        linkBackground={linkBackground}
        linkText={linkText}
        linkColor={linkColor}
        slug={slug}
        data={data}
      />
    </Wrapper>
  );
}

export default WidgetGalleriesGrid;
